<ng-container *ngIf="type === 'squared'">
    <div class="news-content-meta">
        <span class="news-date">{{ date }}</span>
        <hr class="divider" />
    </div>
</ng-container>
<div [ngClass]="['news-card', 'news-card-' + type]" [ngSwitch]="type">
    <!-- Oblique: estilo que está na home -->
    <ng-container *ngSwitchCase="'oblique'">
        <div class="news-image">
            <img [src]="image" [alt]="title" />
        </div>
        <div class="news-content news-content-oblique">
            <h2 class="news-title">{{ title }}</h2>
            <p class="news-summary" *ngIf="summary" [innerHTML]="summary | slice : 0 : 130"></p>
            <div class="news-content-footer">
                <div class="news-publisher" *ngIf="avatar">
                    <div class="news-publisher-avatar">
                        <img [src]="avatar" width="32" height="32" />
                    </div>
                </div>
                <span class="news-date">{{ date }}</span>
                <span class="news-cta"
                    >{{ "GENERAL.READ-MORE" | translate }} <nb-icon icon="arrow-forward-outline"></nb-icon
                ></span>
            </div>
        </div>

        <a [routerLink]="[link]" class="news-link"></a>
    </ng-container>

    <!-- Simple: estilo que está nas páginas internas -->
    <ng-container *ngSwitchCase="'simple'">
        <div class="news-image">
            <img [src]="image" [alt]="title" />
        </div>
        <div class="news-content news-content-simple">
            <h2 class="news-title">{{ title }}</h2>
            <p class="news-summary" *ngIf="summary" [innerHTML]="summary | slice : 0 : 130"></p>
            <div class="news-content-footer">
                <span class="news-date">{{ date }}</span>
                <span class="news-cta">{{ "GENERAL.READ-MORE" | translate }}</span>
            </div>
        </div>

        <a [routerLink]="[link]" class="news-link"></a>
    </ng-container>

    <!-- Simple: estilo que está nas páginas internas -->
    <ng-container *ngSwitchCase="'squared'">
        <div class="news-image news-image-squared">
            <img [src]="image" [alt]="title" />
        </div>
        <div class="news-content news-content-squared">
            <h2 class="news-title">{{ title }}</h2>
            <p class="news-summary" *ngIf="summary" [innerHTML]="summary"></p>
        </div>

        <a [routerLink]="[link]" class="news-link"></a>
    </ng-container>
</div>
